export default {
  route: {
    Home: '首页',
    Orders: '订单中心',
    Members: '会员中心',
    Wallet: '电子钱包',
    Goods: '商品管理',
    GoodsList: '商品列表',
    OrderDetails: '订单详情',
    MembersList: '会员列表',
    DiscountList: '会员价格方案',
    LevelList: '等级列表',
    Withdraw: '提现'
  },
  customize: {
    update: '更新',
    view: '查看',
    edit: '修改',
    search: '搜索',
    reset: '重置',
    loading: '载入中...',

    // home
    shopName: '店铺名称',
    shopLogo: '店铺logo',
    shopAddress: '店铺地址',
    shopDesc: '店铺简介',
    wechatQr: '客服微信',
    uploadFile: '将文件拖到此处，或',
    clickUpload: '点击上传',
    uploadAlert: '只能上传jpg/png文件，且不超过4MB',

    // orders
    orderDetail: '订单详情',
    orderId: '订单号',
    orderCreateAt: '下单时间',
    username: '下单顾客',
    consignee: '收件人',
    totalFee: '总额',
    shippingFee: '运费',
    profit: '利润',
    status: '状态',
    remark: '备注',
    operation: '操作',
    phone: '手机号',
    orderPhoto: '订单照片',
    shippingInfo: '物流信息',
    viewShippingInfo: '查看物流',
    orderActivity: '订单参与的运营活动',
    orderCoupon: '订单使用的优惠券',
    promotionActivity: '运营活动',
    couponActivity: '优惠券',
    originalGoodsFee: '商品原价',
    originalShippingFee: '运费原价',
    discountedGoodsFee: '商品折扣后金额',
    discountedShippingFee: '运费折扣后金额',
    orderShopPrice: '采购订单金额',
    orderFinalPrice: '订单支付总金额',
    agentProfit: '分销利润',
    none: '无',

    // goods
    barcode: '条形码',

    // member
    customerName: '客户姓名',
    memberLevel: '会员等级',
    memberCreateAt: '创建时间',

    // goods
    goodsName: '商品名字',
    goodsImage: '商品图片',
    sku: 'SKU'
  }
}
